import {createApp} from "vue";
import i18n from "./i18n";

import "swiper/css";
import "swiper/css/navigation";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.min.css"
import axios from 'axios';
import VueAxios from 'vue-axios';

import App from "./App.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import RenderVNode from "@/components/RenderVNode";
import ButtonClose from "@/components/ButtonClose";
import ModalStatic from "@/components/ModalStatic";
import AnchorParser from "@/components/AnchorParser";
import {PerfectScrollbar} from "vue3-perfect-scrollbar";

const app = createApp(App);
app.component('swiper', Swiper);
app.component('swiper-slide', SwiperSlide);
app.component('render-vnode', RenderVNode);
app.component('button-close', ButtonClose);
app.component('modal-static', ModalStatic);
app.component('anchor-parser', AnchorParser);
app.component('perfect-scrollbar', PerfectScrollbar);
app
    .use(i18n)
    .use(VueAxios, axios)
    .mount("#website")
;
